import React from "react";

const DEFAULT_SIZE = 14;

type PropsType = {
  size?: number;
};

const Station = ({ size = DEFAULT_SIZE }: PropsType) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M 40 60 L 100 20 L 160 60" />
        <path d="M 55 50 V 120 A 10 10 0 0 0 65 130 H 135 A 10 10 0 0 0 145 120 V 50" />
        <path d="M 100 130 V 160 M 40 170 H 85 M 115 170 H 160" />
        <circle cx="100" cy="170" r="9" />
      </g>
    </svg>
  );
};

export default Station;
